import { render, staticRenderFns } from "./ItsOrderDepartFee.vue?vue&type=template&id=043b5ffe&scoped=true&"
import script from "./ItsOrderDepartFee.vue?vue&type=script&lang=js&"
export * from "./ItsOrderDepartFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043b5ffe",
  null
  
)

export default component.exports